import React, { FC } from 'react'; 
import { ResponsiveBar } from '@nivo/bar'; 
import { useGetFinancialSummaryQuery } from '../api/familyAPI'; 


interface IncomeVsExpensesProps {
  familyId: string;
}

const IncomeVsExpenses: FC<IncomeVsExpensesProps> = ({ familyId }) => {
  const { data, isLoading, error } = useGetFinancialSummaryQuery(familyId);

  const formattedData = data?.summary.map((item: any) => ({
    חודש: item.month.slice(0, 3),
    הכנסות: item.income,
    הוצאות: item.expenses,
    חובות: item.debts,
  })) ?? [];

  if (isLoading) return <div className="text-center p-10">טוען נתונים...</div>;
  if (error) return <div className="text-center p-10 text-red-600">שגיאה בטעינת נתוני גרף</div>;

  return (
    <div
      dir="rtl"
      className="flex flex-col items-center justify-center bg-background p-6 font-sans text-text-main w-full"
    >
      <div className="w-full h-full bg-muted rounded-xl p-4 overflow-hidden">
        <div className="h-[300px] w-full">
          <ResponsiveBar
            data={formattedData}
            keys={['הכנסות', 'הוצאות', 'חובות']}
            indexBy="חודש"
            margin={{ top: 70, right: 80, bottom: 70, left: 60 }}
            padding={0.3}
            groupMode="grouped"
            colors={({ id }) =>
              id === 'הכנסות'
                ? '#2e7d32'
                : id === 'הוצאות'
                  ? '#ffa726'
                  : '#d32f2f'
            }
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'חודש',
              legendPosition: 'middle',
              legendOffset: 40,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'סכום (₪)',
              legendPosition: 'middle',
              legendOffset: -50,
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[
              {
                dataFrom: 'keys',
                anchor: 'top-left',
                direction: 'row',
                translateX: 0,
                translateY: -50,
                itemsSpacing: 50,
                itemWidth: 80,
                itemHeight: 20,
                symbolSize: 15,
                symbolShape: 'circle',
                symbolSpacing: 45,
                itemTextColor: '#212121',
              },
            ]}
            role="application"
            ariaLabel="Bar chart comparing income, expenses, and debts"
          />
        </div>
      </div>
    </div>
  );
};
export default IncomeVsExpenses;
